import React from "react";
import usePromocionesLogic from "./hooks/usePromocionesLogic";
import PromocionesView from "./pages/PromocionesView.jsx";

export default function Promociones() {
  const logic = usePromocionesLogic();
  return <PromocionesView {...logic} />;
}
